import { abyssColors } from '@/theme/colors';
import { Box, Skeleton, Stack } from '@mui/material';
import { accordionStyle, accordionSummaryStyle } from './styles';

interface PoiTypeAccordionSkeletonProps {
  count?: number;
}

export const PoiTypeAccordionSkeleton = ({ count = 3 }: PoiTypeAccordionSkeletonProps) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <Box
          key={`poi-accordion-skeleton-${index}`}
          sx={{
            ...accordionStyle,
            borderBottom: `0.1rem solid ${abyssColors.primary[100]}`,
          }}
          data-testid="poi-accordion-skeleton"
        >
          <Box
            sx={{
              ...accordionSummaryStyle,
              padding: '1.6rem 0.8rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Stack direction="row" alignItems="center" gap="0.8rem">
              <Skeleton
                animation="wave"
                variant="circular"
                width={20}
                height={20}
                sx={{ background: 'transparent' }}
              />
              <Skeleton
                animation="wave"
                variant="text"
                width={120}
                height={24}
                sx={{ background: 'transparent' }}
              />
            </Stack>
            <Skeleton
              animation="wave"
              variant="text"
              width={30}
              height={24}
              sx={{ background: 'transparent' }}
            />
          </Box>
        </Box>
      ))}
    </>
  );
};
